// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hlq0","colMin":"styles_colMin__2I3UZ"};